module.exports = __webpack_public_path__ + "assets/draw-arrow_icon.7e4e10c7.svg";